<div class="fixed bottom-4 right-4 z-50 flex w-full max-w-xs flex-col gap-2">
  @for (toast of toasts(); track toast.id) {
    <div @toastAnimation class="{{ getToastClasses(toast) }}" role="alert">
      <span class="material-icons mr-2">{{ getIcon(toast) }}</span>
      <div class="flex-1">{{ toast.message }}</div>
      <button
        type="button"
        class="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
        (click)="closeToast(toast.id)"
      >
        <span class="material-icons text-sm">close</span>
      </button>
    </div>
  }
</div>
